
export class CreateOpeningTicketInstructionAction {
}

CreateOpeningTicketInstructionAction.schema = {
    type: 'object',
    properties: {
        title: {type: 'string'},
        text: {type: 'string'}
    },
    required: ['title', 'text']
}

export class UpdateOpeningTicketInstructionAction {
}

UpdateOpeningTicketInstructionAction.schema = {
    type: 'object',
    properties: {
        title: {type: 'string'},
        text: {type: 'string'}
    },
    required: ['title', 'text']
}


// WEBPACK FOOTER //
// ./lib/message/models.js